import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const TrolleyCtx = createContext(null);

export const TrolleyProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("bf_trolley")) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);
  const [pulse, setPulse] = useState(0);

  useEffect(() => { localStorage.setItem("bf_trolley", JSON.stringify(items)); }, [items]);

  const value = useMemo(() => {
    const add = (product, variant, qty = 1) => {
      const key = `${product.id}:${variant.variant_id}`;
      setItems((list) => {
        const found = list.find((i) => i.key === key);
        if (found) return list.map((i) => (i.key === key ? { ...i, quantity: i.quantity + qty } : i));
        return [...list, {
          key, product_id: product.id, variant_id: variant.variant_id,
          title: product.title, variant_title: variant.title === "Default Title" ? "" : variant.title,
          price: variant.price, image: (product.images || [])[0] || "", quantity: qty,
        }];
      });
      setPulse((p) => p + 1);
    };
    const setQty = (key, qty) => setItems((l) => (qty <= 0 ? l.filter((i) => i.key !== key) : l.map((i) => (i.key === key ? { ...i, quantity: qty } : i))));
    const remove = (key) => setItems((l) => l.filter((i) => i.key !== key));
    const clear = () => setItems([]);
    const count = items.reduce((s, i) => s + i.quantity, 0);
    const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
    return { items, add, setQty, remove, clear, count, subtotal, open, setOpen, pulse };
  }, [items, open, pulse]);

  return <TrolleyCtx.Provider value={value}>{children}</TrolleyCtx.Provider>;
};

export const useTrolley = () => useContext(TrolleyCtx);
